import { render, staticRenderFns } from "./widgetsettings.vue?vue&type=template&id=2aefd858&"
import script from "./widgetsettings.vue?vue&type=script&lang=js&"
export * from "./widgetsettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports